import { render, staticRenderFns } from "./voteCard.vue?vue&type=template&id=63040e02&"
import script from "./voteCard.vue?vue&type=script&lang=js&"
export * from "./voteCard.vue?vue&type=script&lang=js&"
import style0 from "./voteCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports